import BaseComponent from '../../../general/js/base-component';
import Handlebars from 'handlebars';
import ComponentsCollection from "../../../general/js/components-collection";

export default class SubformListComponent extends BaseComponent {
    constructor() {
        super(...arguments);

        this.addButton = this.refs.addButton;
        this.list = this.refs.list;

        this.templateId = this.options.template || '';
        this.max = this.options.max || 0;

        this.id = 0;

        /**
         * [{element, removeButtonElement, removeHandler}]
         * @type {Array}
         */
        this.subforms = [];

        this.onAddClick = this.onAddClick.bind(this);

        this.init();
    }

    static getRequiredRefs() {
        return ['list', 'addButton'];
    }

    init() {
        if (!this.templateId) {
            return;
        }

        let source = document.getElementById(this.templateId).innerHTML;
        this.template = Handlebars.compile(source);
        this.addButton.addEventListener('click', this.onAddClick);
    }

    onAddClick(e) {
        e.preventDefault();
        if (this.max === 0 || this.subforms.length < this.max) {
            this.addSubform();
        }
    }

    addSubform() {

        let number = this.subforms.length + 1;

        let element = document.createElement("div");
        element.classList.add('subform');
        element.innerHTML = this.template({number, i: this.id});
        this.list.insertAdjacentElement('beforeEnd', element);

        let subformData = {
            element,
            removeButton: element.querySelector('.js-subform-remove-button'),
            removeHandler: (e) => {
                e.preventDefault();
                this.removeSubform(subformData);
            },
            id: this.id,
        };

        this.id++;

        if (subformData.removeButton) {
            subformData.removeButton.addEventListener('click', subformData.removeHandler);
        }

        this.subforms.push(subformData);

        if (this.max > 0 && this.subforms.length >= this.max) {
            this.addButton.classList.add('is-hidden');
        }

        ComponentsCollection.getInstance().init(element);
        this.onSubformConnected(subformData);
    }

    onSubformConnected(data) {
        // hook
    }

    onSubformDisconnected(data) {
        // hook
    }

    removeSubform(data) {
        this.disconnectSubform(data);
        this.subforms = this.subforms.filter(item => item !== data);
        this.updateAddButtonVisibility();
        this.updateNumbers();
        this.id--;
    }

    updateNumbers() {
        this.subforms.forEach((item, i) => {
            let number = i + 1;
            let numbers = [...item.element.querySelectorAll('.js-subform-number')];
            numbers.forEach(numberElement => numberElement.textContent = number);

            let subformFields = [...item.element.querySelectorAll('input, select')];
            subformFields.forEach(element => element.name = element.name.replace(element.name.match(/\[.+\]/g), '[' + i + ']'));
        });
    }

    disconnectSubform(data, i) {
        let element = data.element;
        if (data.removeButton) {
            data.removeButton.removeEventListener('click', data.removeHandler);
        }
        this.onSubformDisconnected(data, i);
        ComponentsCollection.getInstance().destroy(element);
        element.parentNode.removeChild(element);
    }

    removeAll(){
        this.subforms.forEach((item, i) => this.disconnectSubform(item, i));
        this.subforms = [];
        this.updateAddButtonVisibility();
        this.index = 0;
        this.id = 0;
    }

    updateAddButtonVisibility() {
        if (this.subforms.length < this.max) {
            this.addButton.classList.remove('is-hidden');
        }
    }

    hide(){
        this.element.classList.add('is-hidden');
    }

    show(){
        this.element.classList.remove('is-hidden');
    }
}



// WEBPACK FOOTER //
// ./app/components/register-to-bid/js/subform-list.component.js